<template>
  <div
    :class="`progress-indicator text-small bold variant ${size}`"
    :data-variant="variant"
    data-apply-color
  >
    {{ completed }}% <progress-bar :completed="completed" :variant="variant" />
  </div>
</template>

<script>
/**
 * This component shows progress percentage and its visual representation in horizontal filled bar
 */
import ProgressBar from '@/components/ProgressBar'

export default {
  name: 'ProgressIndicator',
  props: {
    variant: { type: String },
    completed: { type: Number },
    /**
     * @values md, lg
     */
    size: { type: String, default: 'md' }
  },
  components: {
    ProgressBar
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.progress-indicator {
  width: 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
  padding: 2px 0;
  text-align: center;
}
.progress-indicator.lg {
  font-size: 1.5rem;
  &,
  .progressor-wrapper {
    width: 80px;
  }
}
</style>
